import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { formatVnd } from '@/lib/format';
import { ChartCard } from './chart-card';
import { Skeleton } from '@/components/ui/skeleton';

interface TopMerchantsProps {
  department?: string;
  dateFrom?: string;
  dateTo?: string;
  all?: boolean;
}

export function TopMerchants({ department, dateFrom, dateTo, all }: TopMerchantsProps) {
  const { data, isLoading } = useQuery({
    queryKey: [
      'dashboard-top-merchants',
      department ?? null,
      all ? 'all' : (dateFrom ?? null),
      dateTo ?? null,
    ],
    queryFn: () => api.getTopMerchants({ department, date_from: dateFrom, date_to: dateTo, all }),
  });
  const rows = data?.rows ?? [];
  const total = rows.reduce((s, r) => s + r.total_vnd, 0);

  return (
    <ChartCard title="Top merchants" description="Khoảng đã chọn" contentClassName="px-4 pb-5">
      {isLoading ? (
        <div className="space-y-2">
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton key={i} className="h-6 w-full" />
          ))}
        </div>
      ) : rows.length === 0 ? (
        <div className="flex h-[240px] items-center justify-center text-sm text-muted-foreground">
          Không có giao dịch trong khoảng này
        </div>
      ) : (
        <ul className="space-y-2 text-xs">
          {rows.map((r) => {
            const pct = total > 0 ? Math.round((r.total_vnd / total) * 100) : 0;
            return (
              <li key={r.merchant} className="flex items-center gap-2">
                <span className="flex-1 truncate text-foreground">{r.merchant}</span>
                <span className="shrink-0 font-mono tabular-nums text-muted-foreground/80">
                  {r.tx_count}×
                </span>
                <span className="shrink-0 font-mono tabular-nums text-muted-foreground">
                  {formatVnd(r.total_vnd)}
                </span>
                <span className="w-9 shrink-0 text-right tabular-nums text-muted-foreground/70">
                  {pct}%
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </ChartCard>
  );
}
